module.exports = __webpack_public_path__ + "static/media/video1.ec739158.jpg";